<div class="w-full max-w-5xl p-8">
    @if (!showAccessRequestForm && !showMyRequests) {
        <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px] flex flex-row">
            <button mat-button (click)="goToAssistsOverview()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
            </button>
            <h2 class="!mt-0 content-center">{{ 'label_access_request' | translate }}</h2>
        </div>
        <span class="separator-line block mb-px"></span>
        <br />
        <div class="grid grid-cols-1 gap-8 w-full mt-4">
            <div class="grid gap-8 sm:grid-flow-col xl:grid-flow-row">
                <div
                    (click)="redirectToJiraForm()"
                    class="request-container relative flex flex-col flex-auto p-6 pr-3 pb-3 bg-card rounded-2xl shadow overflow-hidden"
                >
                    <div class="absolute bottom-0 right-0 w-24 h-24 -m-6">
                        <mat-icon class="icon-size-24 opacity-25 text-green-500" [svgIcon]="'heroicons_outline:user-plus'"></mat-icon>
                    </div>
                    <div class="flex items-center">
                        <div class="flex flex-col">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate mb-[5px]">
                                {{ 'label_new_employee_request' | translatePlural }}
                            </div>
                            <div class="text-secondary font-medium text-md">
                                {{ 'text_new_employee_request' | translatePlural }}
                            </div>
                        </div>
                    </div>
                    <span class="text-md c-link mt-1 text-primary">{{ 'label_register_request' | translate }}</span>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-1 gap-8 w-full mt-4">
            <div class="grid gap-8 sm:grid-flow-col xl:grid-flow-row">
                <div
                    (click)="goToAccessRequestForm()"
                    class="request-container relative flex flex-col flex-auto p-6 pr-3 pb-3 bg-card rounded-2xl shadow overflow-hidden"
                >
                    <div class="absolute bottom-0 right-0 w-24 h-24 -m-6">
                        <mat-icon
                            class="icon-size-24 opacity-25 text-blue-500 dark:text-blue-400"
                            [svgIcon]="'heroicons_outline:globe'"
                        ></mat-icon>
                    </div>
                    <div class="flex items-center">
                        <div class="flex flex-col">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate mb-[5px]">
                                {{ 'label_access_request_system' | translatePlural }}
                            </div>
                            <div class="text-secondary font-medium text-md">
                                {{ 'text_access_request_system' | translatePlural }}
                            </div>
                        </div>
                    </div>
                    <span class="text-md c-link mt-1 text-primary">{{ 'label_register_request' | translate }}</span>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-1 gap-8 w-full mt-4">
            <div class="grid gap-8 sm:grid-flow-col xl:grid-flow-row">
                <div
                    (click)="goToMyRequests()"
                    class="request-container relative flex flex-col flex-auto p-6 pr-3 pb-3 bg-card rounded-2xl shadow overflow-hidden"
                >
                    <div class="absolute bottom-0 right-0 w-24 h-24 -m-6">
                        <mat-icon class="icon-size-24 opacity-25 text-orange-500" [svgIcon]="'heroicons_outline:list-bullet'"></mat-icon>
                    </div>
                    <div class="flex items-center">
                        <div class="flex flex-col">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate mb-[5px]">
                                {{ 'label_my_requests' | translatePlural }}
                            </div>
                            <div class="text-secondary font-medium text-md">
                                {{ 'text_my_requests' | translatePlural }}
                            </div>
                        </div>
                    </div>
                    <span class="text-md c-link mt-1 text-primary">{{ 'label_open_request' | translatePlural }}</span>
                </div>
            </div>
        </div>
    }

    @if (form && showAccessRequestForm) {
        <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px] flex flex-row">
            <button mat-button (click)="goToAccessRequestOverview()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
            </button>
            <h2 class="!mt-0 content-center">{{ 'label_access_request_system' | translatePlural }}</h2>
        </div>
        <span class="separator-line block mb-px"></span>
        <br />
        <form [formGroup]="form" #profileInNgForm="ngForm">
            <div class="grid sm:grid-cols-4 gap-6 w-full">
                <ng-container>
                    <div class="col-span-4">
                        <mat-form-field class="w-full">
                            <mat-label>{{ 'label_title' | translate }}</mat-label>
                            <input [formControlName]="'summary'" maxlength="255" matInput />
                            <mat-hint class="ml-auto">
                                <span
                                    class="bold"
                                    [ngClass]="{
                                        'notification-color': this.form?.get('summary')?.value?.length > 190,
                                    }"
                                >
                                    {{ 255 - this.form?.get('summary')?.value?.length }}
                                </span>
                                {{
                                    'info_characters_left'
                                        | translate
                                            : {
                                                  count: 255 - this.form?.get('summary')?.value?.length,
                                              }
                                        | lowercase
                                }}
                            </mat-hint>
                        </mat-form-field>
                    </div>
                    <div class="col-span-4 md:col-span-3">
                        <mat-form-field class="w-full">
                            <mat-label>{{ 'label_system' | translate }}</mat-label>
                            <mat-select [formControlName]="'customfield_10068'" [placeholder]="'label_operational_systems' | translate">
                                @for (type of systemDropDown; track type) {
                                    <mat-option [value]="type.value">
                                        {{ type.viewValue }}
                                    </mat-option>
                                }
                            </mat-select>
                            <mat-hint [innerHTML]="systemTooltip"></mat-hint>
                        </mat-form-field>
                    </div>
                    <div class="col-span-4 md:col-span-1">
                        <mat-label class="font-[500] mb-1 material-form-title" [ngClass]="{ 'opacity-60': !formEnabled }">{{
                            'label_access_type' | translate
                        }}</mat-label>
                        <br />
                        @for (issueType of accessTypeDropDown; track issueType; let i = $index) {
                            <div class="checkbox-compact">
                                <mat-checkbox
                                    [disabled]="this.form.disabled"
                                    class="ml-[10px] mt-[2px]"
                                    (change)="onChangeAccessType($event)"
                                    [value]="issueType.value"
                                >
                                    {{ issueType.viewValue }}
                                </mat-checkbox>
                            </div>
                        }
                    </div>
                    <div class="col-span-4">
                        <div
                            class="text-[14px] font-medium mb-1"
                            [ngClass]="{
                                'validation-error-color': form?.get('description')?.hasError('required') && submitted,
                                'opacity-60': !formEnabled,
                            }"
                        >
                            {{ 'label_access_info' | translate }} *
                        </div>
                        <ckeditor
                            [disabled]="form?.get('description')?.disabled"
                            [editor]="descriptionEditor"
                            [(ngModel)]="descriptionTextHTML"
                            name="descriptionTextHTML"
                            [ngModelOptions]="{ standalone: true }"
                            [config]="editorConfig"
                            (ready)="onEditorReady($event)"
                            (change)="descriptionOnChange($event)"
                            id="editorDescription"
                        ></ckeditor>
                        <mat-hint [innerHTML]="descriptionTooltip"></mat-hint>
                    </div>
                    <div class="col-span-4">
                        <ngx-dropzone
                            class="custom-dropzone"
                            class="justify-center"
                            (change)="onSelect($event)"
                            [disabled]="this.form.disabled"
                        >
                            <ngx-dropzone-label>
                                <div>
                                    <h2>
                                        {{ 'info_add_attachment' | translate }}
                                    </h2>
                                    <mat-icon class="mt-1 icon-size-7" svgIcon="feather:file"></mat-icon>
                                </div>
                            </ngx-dropzone-label>
                            @for (f of files; track f) {
                                <ngx-dropzone-preview [removable]="true" (removed)="onRemove(f)">
                                    <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
                                </ngx-dropzone-preview>
                            }
                        </ngx-dropzone>
                    </div>
                </ng-container>
            </div>
            <div class="flex items-center justify-end mt-[20px]">
                @if (form.dirty) {
                    <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                        {{ 'label_cancel' | translate }}
                    </button>
                }
                <button class="ml-4" (click)="submit()" mat-flat-button type="submit" [color]="'primary'" [disabled]="!formEnabled">
                    @if (formEnabled) {
                        <span>
                            {{ 'label_register_request' | translate }}
                        </span>
                    }
                    @if (!formEnabled) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                    }
                </button>
            </div>
        </form>
    }
    @if (showMyRequests) {
        <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px] flex flex-row">
            <button mat-button (click)="goToAccessRequestOverview()">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
            </button>
            <h2 class="!mt-0 content-center">{{ 'label_my_requests' | translatePlural }}</h2>
        </div>
        <span class="separator-line block mb-px"></span>
        <br />
        <div>
            <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="displayedData" class="w-[100%]">
                <ng-container matColumnDef="key">
                    <th mat-sort-header="key" mat-header-cell *matHeaderCellDef>
                        {{ 'label_audkenni' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <a class="c-link" target="_blank" [matTooltip]="'label_view_request_plain' | translate" href="{{ element.url }}">{{
                            element.key
                        }}</a>
                    </td>
                </ng-container>
                <ng-container matColumnDef="title">
                    <th mat-sort-header="title" mat-header-cell *matHeaderCellDef>
                        {{ 'label_title' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <a class="c-link" target="_blank" [matTooltip]="'label_view_request_plain' | translate" href="{{ element.url }}">{{
                            element.title
                        }}</a>
                    </td>
                </ng-container>
                <ng-container matColumnDef="created">
                    <th mat-sort-header="created" mat-header-cell *matHeaderCellDef>
                        {{ 'label_date' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span [matTooltip]="'label_registered_at_plain' | translate">{{ formatDate(element.created) }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-sort-header="status" mat-header-cell *matHeaderCellDef>
                        {{ 'label_status' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span
                            class="inline-flex items-center font-bold text-xs px-2.5 py-0.5 rounded-full tracking-wide uppercase"
                            [ngClass]="{
                                'bg-orange-200 text-orange-800 dark:bg-orange-600 dark:text-orange-50': element.status === 'Móttekið',
                                'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50': element.status === 'Hætt við',
                                'bg-blue-200 text-blue-800 dark:bg-blue-600 dark:text-blue-50':
                                    element.status !== 'Móttekið' &&
                                    element.status !== 'Hætt við' &&
                                    element.status !== 'Lokið' &&
                                    element.status !== 'Leyst',
                                'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50':
                                    element.status === 'Lokið' || element.status === 'Leyst',
                            }"
                        >
                            <span class="leading-relaxed whitespace-nowrap">{{ element.status }}</span>
                        </span>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="orgRequestsColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: orgRequestsColumns"></tr>
                <tr class="mat-row" [ngClass]="{ 'h-0': isLoading }" *matNoDataRow>
                    @if (!isLoading && initialFetchComplete) {
                        <div class="flex items-center justify-between">
                            <span>
                                <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">
                                    {{ 'info_requests_found_plain' | translate }}
                                </div>
                            </span>
                        </div>
                    }
                </tr>
            </table>
            @if (isLoading) {
                <div class="flex justify-center items-center gap-2 pt-4 pb-4 bg-white">
                    <mat-progress-spinner [diameter]="16" [mode]="'indeterminate'"> </mat-progress-spinner>
                    Sæki beiðnir
                </div>
            }
            @if (!isLastPage) {
                <div #sentinel class="h-1"></div>
            }
        </div>
    }
</div>
